<template>
  <span
    v-show="!overflow"
    ref="textRef"
    class="one-line-text"
    :class="className"
  >
    {{ text || '-' }}
  </span>
  <u-tooltip
    v-if="overflow"
    :mouse-enter-delay="0.5"
    dropdown-class="one-line-text-tooltip"
  >
    <template #title>
      <div class="one-line-text-tooltip__content">
        {{ text || '-' }}
      </div>
    </template>
    <span class="one-line-text" :class="className">
      {{ text || '-' }}
    </span>
  </u-tooltip>
</template>

<script>
import { nextTick, ref, watch } from 'vue';

export default {
  name: 'OneLineText',
  props: {
    text: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const overflow = ref(false);
    const textRef = ref(null);

    const handleTextReload = () => {
      if (textRef.value) {
        const clonedNode = textRef.value.cloneNode(true);
        clonedNode.style.overflow = 'visible';
        clonedNode.style.display = 'inline-block';
        clonedNode.style.width = 'auto';
        clonedNode.style.maxWidth = 'none';
        clonedNode.style.whiteSpace = 'nowrap';
        clonedNode.style.visibility = 'hidden';
        document.body.appendChild(clonedNode);
        if (textRef.value.offsetWidth < clonedNode.offsetWidth) {
          overflow.value = true;
        }
        document.body.removeChild(clonedNode);
      }
    };

    watch(
      () => props.text,
      () => {
        nextTick(() => {
          handleTextReload();
        });
      },
      { immediate: true }
    );

    return {
      overflow,
      textRef
    };
  }
};
</script>

<style lang="less">
.one-line-text {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: inherit;
}

// Optimize tooltip to prevent overflow beyond screen boundaries
.one-line-text-tooltip {
  max-width: min(80vw, 400px) !important;
}

.one-line-text-tooltip__content {
  max-height: min(80vh, 400px);
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
